import { useState } from "react";
import { InfoWindow } from "@react-google-maps/api";
import { getOrderDetails } from "../../services/orderService";
import OrderDetailsPopup from "../../order/OrderDetailsPopup";
import ETA from "./ETA";

const DriverInfoWindow = ({
  driver,
  onClose,
  renderOrderStatus,
  updateSelectedDriver,
  followTargetId,
}) => {
  const [details, setDetails] = useState({});
  const [popup, setPopup] = useState(false);
  const [loadingOrderId, setLoadingOrderId] = useState(null);

  if (!driver) return null;

  const lat = Number(driver._position?.lat ?? driver.location?.lat);
  const lng = Number(driver._position?.long ?? driver.location?.long);

  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

  const showOrderDetails = async (orderId) => {
    setLoadingOrderId(orderId);
    const res = await getOrderDetails(orderId);
    setLoadingOrderId(null);
    if (res?.data?.code === 1) {
      setDetails(res.data.data);
      setPopup(true);
    }
  };

  return (
    <>
      <InfoWindow
        anchor={driver._marker}
        position={{ lat, lng }}
        onCloseClick={onClose}
        options={{
          disableAutoPan: true,
          pixelOffset: new window.google.maps.Size(0, -50),
        }}
      >
        <div className="p-3 shadow-sm rounded bg-body text-body">
          <div className="d-flex align-items-center mb-3">
            <img
              src={`${process.env.REACT_APP_API_PUBLIC_URL}${driver.driverPhoto}`}
              alt={driver.driverName}
              className="rounded-circle me-3 border border-success"
              style={{ width: "48px", height: "48px", objectFit: "cover" }}
            />
            <div>
              <h6 className="mb-0">{driver.driverName}</h6>
              <small className="text-primary">{driver.driverPhone}</small>
            </div>
          </div>

          <ETA selectedDriver={driver} />

          {driver.orders?.length > 0 ? (
            <div className="table-responsive">
              <table className="table table-sm table-bordered text-body mb-3">
                <tbody>
                  <tr className="text-center text-dark">
                    <th>Order Id</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                  {driver.orders.map((o) => (
                    <tr key={o._id}>
                      <td className="text-dark">{o.orderId}</td>
                      <td>{renderOrderStatus(o.status)}</td>
                      <td>
                        <button
                          className="btn btn-sm btn-primary py-0"
                          disabled={loadingOrderId === o._id}
                          onClick={() => showOrderDetails(o._id)}
                        >
                          {loadingOrderId === o._id ? (
                            <span className="dots-loader">
                              <span
                                className="dot spinner-grow"
                                role="status"
                              ></span>
                              <span
                                className="dot spinner-grow"
                                role="status"
                              ></span>
                              <span
                                className="dot spinner-grow"
                                role="status"
                              ></span>
                              <span
                                className="dot spinner-grow"
                                role="status"
                              ></span>
                            </span>
                          ) : (
                            <>
                              <small>DETAILS</small>
                            </>
                          )}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="p-5 mx-5">No Current Order</div>
          )}

          <div className="d-flex justify-content-center gap-2">
            <button className="btn btn-danger btn-sm" onClick={onClose}>
              Close
            </button>
            {followTargetId === driver?.driverId ? (
              <button
                className="btn btn-sm btn-danger"
                onClick={() => updateSelectedDriver(driver?.driverId, false)}
              >
                Unfollow
              </button>
            ) : (
              <button
                className="btn btn-sm btn-primary"
                onClick={() => updateSelectedDriver(driver?.driverId, true)}
              >
                Follow
              </button>
            )}
          </div>
        </div>
      </InfoWindow>
      <OrderDetailsPopup order={details} popup={popup} setPopup={setPopup} />
    </>
  );
};

export default DriverInfoWindow;
